import { gql } from "@apollo/client"

export const GET_USERS = gql`
  query Users($staff_id: ID!, $organization_id: ID!) {
    users: staffsByOrganization(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      staff_id
      staff_alias
      staff_user_status
      staff_name_first
      staff_name_last
      staff_email_address
      staff_role_name
    }

    participants: participantAdvancedSearch(
      staff_id: $staff_id
      organization_id: $organization_id
      search_type: "all_participants"
    ) {
      participant_id
      participant_alias
      participant_name_first
      participant_name_last
      participant_email_account
      participant_membership_status
    }
  }
`

export const GET_USERS_FROM_LIST = gql`
  query Users($list: [ID!]) {
    users: usersFromList(list: $list) {
      staff_id
      staff_alias
      staff_name_first
      staff_name_last
      staff_email_address
      staff_user_status
      staff_role_name
    }
  }
`
